import * as actionTypes from './actionTypes';

export const updateReport = (val) => {
  return {
    type: actionTypes.UPDATE_REPORT,
    val: val
  }
}


export const addReportCharts = (val) => {
  return {
    type: actionTypes.ADD_REPORT_CHARTS,
    val: val
  }
}

export const updateReportCharts = val =>{
  return {
    type: actionTypes.UPDATE_REPORT_CHARTS,
    val: val
  }
}



export const createDashboardReport = val =>{
  return {
    type: actionTypes.CREATE_DASHBOARD_REPORT,
    val: val
  }
}